import styled from 'styled-components';

export const CTAButtonTopBottomBlock = styled('div')`
  text-align: center;
  height: 25px;
  margin: 5px;
`;
